// extracted by mini-css-extract-plugin
module.exports = {"chip":"_1cUWUeQptA5DaD5XWkvjAl","icon":"_3ebo8liBPUKEdbbcxkPSnB"};